// extracted by mini-css-extract-plugin
export default {"root":"classes_root__VEs9p","submit-button":"classes_submit-button__G7A-O"};